import { IconType } from "react-icons";
import { FiChevronDown, FiBookmark, FiFileText, FiSearch } from "react-icons/fi";
import {
  FaBars,
  FaChevronRight,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaCheck,
  FaBookmark,
  FaPhone,
  FaClock,
  FaEye,
  FaEyeSlash,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebook,
  FaUser,
  FaStoreAlt,
  FaImage,
  FaSort,
  FaHome,
  FaBox,
  FaCog,
  FaSignOutAlt,
  FaTag,
  FaUserFriends,
  FaUserTie,
  FaClipboardList,
  FaSearch,
  FaDatabase,
  FaFileAlt,
  FaFolder,
  FaUndo,
  FaPrint,
  FaCheckCircle,
  FaFilter,
} from "react-icons/fa";
import { LiaSpinnerSolid } from "react-icons/lia";
import { BiLoaderCircle } from "react-icons/bi";
import { FaXTwitter } from "react-icons/fa6";
import { BsCart } from "react-icons/bs";
import { FaChartBar, FaChartLine, FaChartPie, FaHistory } from "react-icons/fa";

interface IconList {
  [key: string]: IconType | React.ComponentType | string;
}

const IconsList: IconList = {
  // Navegación y UI
  user: FaUser,
  cart: BsCart,
  menu: FaBars,
  shop: FaStoreAlt,
  rightArrow: FaChevronRight,
  downArrow: FaChevronDown,
  regularDownArrow: FiChevronDown,
  upArrow: FaChevronUp,
  close: FaTimes,
  angleRight: FaChevronRight,
  check: FaCheck,
  
  // Ubicación y contacto
  location: FaMapMarkerAlt,
  phone: FaPhone,
  clock: FaClock,
  
  // Redes sociales
  instagram: FaInstagram,
  facebook: FaFacebook,
  xTwitter: FaXTwitter,
  
  // Bookmarks
  regularBookmark: FiBookmark,
  solidBookmark: FaBookmark,
  
  // Otros
  search: FaSearch,
  regularSearch: FiSearch,
  filter: FaFilter,
  eye: FaEye,
  eyeOff: FaEyeSlash,
  imageOff: FaImage,
  arrowUnsorted: FaSort,
  spinner: LiaSpinnerSolid,
  loader: BiLoaderCircle,
  
  // Archivos y configuración
  database: FaDatabase,
  file: FaFileAlt,
  folder: FaFolder,
  fileText: FiFileText,
  
  // Visualización
  restore: FaUndo,
  printer: FaPrint,
  checkCircle: FaCheckCircle,
  
  // Iconos del dashboard/sidebar
  home: FaHome,
  inicio: FaHome,
  recursos: FaDatabase,
  productos: FaBox,
  precios: FaTag,
  clientes: FaUserFriends,
  profesionales: FaUserTie,
  pedidos: FaClipboardList,
  estadisticas: FaChartBar,
  configuracion: FaCog,
  logout: FaSignOutAlt,
  chartBar: FaChartBar,
  chartLine: FaChartLine,
  chartPie: FaChartPie,
  history: FaHistory,
};

export default IconsList;
